import { useState, Fragment } from "react";
import { Input, Col, Row } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function SelectCoursesAndModules(props) {
  const [courseDropdown, setCourseDropdown] = useState(null);

  let mappedCourses = () => {
    return props.courses.map((course) => (
      <Fragment key={course.id}>
        <Row>
          <Col
            lg={1}
            xs={1}
            onClick={() =>
              setCourseDropdown(courseDropdown !== course.id ? course.id : null)
            }
          >
            <FontAwesomeIcon
              className="text-primary"
              icon={
                courseDropdown !== course.id ? "plus-square" : "minus-square"
              }
            />
          </Col>
          <Col lg={5} xs={6}>
            {course.courseName}
          </Col>
          <Col lg={3} xs={2}>
            <Input
              type="checkbox"
              checked={props.selectedCourse === course.id}
              onChange={(event) => props.handleCheckCourses(event, course.id)}
            />
          </Col>
        </Row>
        {course.modules.map((mod, i) => (
          <Row key={"m" + i} hidden={courseDropdown !== course.id}>
            <Col xs={2} lg={2}></Col>
            <Col xs={6} lg={5}>
              {mod.name}
            </Col>
            <Col xs={3} lg={3}>
              <Input
                type="checkbox"
                checked={props.selectedModules.includes(mod.moduleId)}
                disabled={props.selectedCourse !== course.id}
                onChange={(event) =>
                  props.handleCheckModules(event, mod.moduleId)
                }
              />
            </Col>
          </Row>
        ))}
        <hr className="p-0 m-1" />
      </Fragment>
    ));
  };

  return <div>{mappedCourses()}</div>;
}
